import { render, staticRenderFns } from "./modalAdd.vue?vue&type=template&id=48ee8814&"
import script from "./modalAdd.vue?vue&type=script&lang=js&"
export * from "./modalAdd.vue?vue&type=script&lang=js&"
import style0 from "./modalAdd.vue?vue&type=style&index=0&id=48ee8814&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports